import { consultar } from 'helpers/api';
//import { AppHelper } from 'helpers/AppHelper';

const controller = "cobrancas";

export const CobrancasService = {
   getPIX,
   alterarVencimento,
   registrarPagamento,
   cancelarCobranca,
   reprogramarVencimentos
}

async function getPIX(id) {
   return await consultar(`/${controller}/getPix/${id}.json`);
}

async function alterarVencimento(id, params) {
   return await consultar(`/${controller}/alterarVencimento/${id}.json`, 'post', params);
}

async function registrarPagamento(id, params) {
   return await consultar(`/${controller}/registrarPagamento/${id}.json`, 'post', params);
}

async function cancelarCobranca(id, params) {
   return await consultar(`/${controller}/cancelarCobranca/${id}.json`, 'post', params);
}

async function reprogramarVencimentos(id, params) {
   return await consultar(`/${controller}/reprogramarVencimentos/${id}.json`, 'post', params);
}
